import { z } from "zod";
import { KNOWN_TERMS_VERSIONS } from "../legal/legal-versions.js";
/**
 * `POST /crm/terms/accept`. An enum, not a free string: the version is written
 * to an audit table as the name of the text a person agreed to, so an arbitrary
 * value would be a record of accepting a document that never existed.
 */
export const acceptTermsSchema = z.object({
    version: z.enum(KNOWN_TERMS_VERSIONS),
});
//# sourceMappingURL=legal.js.map